import {sendGetRequest, sendPostRequest, sendPutRequest} from '../requests';
import {QueryParamsProps} from '../../constants/types';

const baseUrl = '/tasks';

type CompleteTaskBody = {
  answers: Dictionary<string | number>[]
}

export const getAllTasks = (params: QueryParamsProps) =>
  sendGetRequest(baseUrl, params);

export const getTask = (taskId: number) =>
  sendGetRequest(`${baseUrl}/${taskId}`);

export const claimTask = (taskId: number) =>
  sendPostRequest(`${baseUrl}/${taskId}/claim`);

export const getAvailableAssignees = (taskId: number) =>
  sendGetRequest(`${baseUrl}/${taskId}/available-assignees`);

export const reassignTask = (taskId: number, assigneeId: number) =>
  sendPutRequest(`${baseUrl}/${taskId}/reassign?assigneeId=${assigneeId}`);

export const completeTask = (
    taskId: number,
    answers: CompleteTaskBody
) =>
  sendPostRequest(`${baseUrl}/${taskId}/complete`, answers);

export const getEmployeeSatisfactionStatuses = () =>
  sendGetRequest('/nomenclature/employee-satisfaction-statuses');

export const getEmployeeStuckItems = () =>
  sendGetRequest('/nomenclature/employee-stuck-items');

export const getTasksAfterGiven = (taskId: number) =>
  sendGetRequest(`${baseUrl}/${taskId}/created-after`);
